import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import Bread from "../../common/Bread";
import CeoMessage from "../../components/CeoMessage";
import CompanyProfile from "../../components/CompanyProfile";
import { LangContext } from "../../context/LangContext";
import "./about.scss";

const About = () => {
  const { slug } = useParams();

  const lang = useContext(LangContext);
  const nep = lang.state.np;

  const getTitle = () => {
    switch (slug) {
      case "ceo-message":
        return nep ? "सीईओको सन्देश" : "CEO Message";

      case "company-profile":
        return nep ? "कम्पनी प्रोफाइल" : "Company Profile";

      default:
        return nep ? "हाम्रो बारेमा" : "About Us";
    }
  };

  const breadcrumList = {
    image: "",
    title: getTitle(),
    l1: nep ? "होम" : "Home",
    l2: nep ? "हाम्रो बारेमा" : "About Us",
    l3: "",
  };

  return (
    <Bread data={breadcrumList}>
      <div>
        {slug === "ceo-message" ? (
          <CeoMessage />
        ) : slug === "company-profile" ? (
          <CompanyProfile />
        ) : (
          <h1>{nep ? "फेला परेन" : "Not Found"}</h1>
        )}
      </div>
    </Bread>
  );
};

export default About;
